import { SEARCHABLE_DM_USERS_QUERY } from 'schema-v2/Chat/queries';

import { useUsersSearch } from 'components/new/hooks/useUsersSearch';

interface DMUserSearchEdge {
  node: {
    user: {
      fullName: string;
      gid: string;
      profile: {
        avatar: {
          url: string;
          altText: string;
        };
      };
    };
  };
}

export interface UserResult {
  gid: string;
  display: string;
  avatarUrl: string;
}

// Map unified DM users to simplified UserResult format
const mapDMUserObject = (userData: DMUserSearchEdge[]): UserResult[] => {
  const users = userData || [];
  return users
    .filter((userNode) => {
      const user = userNode?.node?.user;
      return user?.fullName && user?.gid;
    })
    .map(({ node }) => ({
      gid: node.user.gid,
      display: node.user.fullName,
      avatarUrl: node.user.profile?.avatar?.url || '',
    }));
};

export const useDMUsersSearch = (): {
  handleSearch: (search: string) => Promise<UserResult[]>;
} => {
  // Use the general useUsersSearch hook with DM-specific configuration
  return useUsersSearch<UserResult>(
    SEARCHABLE_DM_USERS_QUERY,
    true, // isUnifiedQuery = true
    mapDMUserObject,
    'site.searchableDmUsers.edges',
    undefined,
    'no-cache'
  );
};
